import ApiService from '@/services/core/api.service'

const ReplenishmentService = {
  async get (query = '') {
    return ApiService.get(`disbursement-associate/reports/checks?${query}`)
  },

  async export (query = '') {
    return ApiService.get(`disbursement-associate/exports/checks?${query}`)
  }
}

export default ReplenishmentService
